var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_335_8142)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 45,
    height: 44,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 44,
    height: 43,
    rx: 7.5,
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7868 23.952L25.4222 15.9804L20.0894 11.8777L23.243 21.4652L25.6851 28.8963L28.0237 36L35.7809 23.9841L35.7927 23.9666L35.7868 23.952Z",
    fill: "#0075FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7868 23.952L25.4222 15.9804L20.0894 11.8777L23.243 21.4652L25.6851 28.8963L28.0237 36L35.7809 23.9841L35.7927 23.9666L35.7868 23.952Z",
    fill: "url(#paint0_linear_335_8142)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7871 23.952L28.5939 8L25.4225 15.9804L23.2433 21.4652L19 32.1486L25.6853 28.8963L35.7812 23.9841L35.793 23.9666L35.7871 23.952Z",
    fill: "#0075FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7871 23.952L28.5939 8L25.4225 15.9804L23.2433 21.4652L19 32.1486L25.6853 28.8963L35.7812 23.9841L35.793 23.9666L35.7871 23.952Z",
    fill: "url(#paint1_linear_335_8142)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_335_8142",
    x: 0,
    y: 0,
    width: 53,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_335_8142"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.211765 0 0 0 0 0.294118 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_335_8142"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_335_8142"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.211765 0 0 0 0 0.294118 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_335_8142",
    result: "effect2_dropShadow_335_8142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_335_8142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_335_8142",
    x1: 35.7927,
    y1: 11.8777,
    x2: 20.0894,
    y2: 11.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_335_8142",
    x1: 35.793,
    y1: 8,
    x2: 19,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.695c321fa73cd1ef7f6d575664e8f66b.svg";
export { ForwardRef as ReactComponent };